<dx-tree-list #attributesTreeList [height]="treeListHeight" [class]="!isReadOnly ? 'treelist-negative-margin-top' : 'noClass'"
              [dataSource]="dataSourceDocumentAttributes"
              keyExpr="DocumentAttributeId"
              parentIdExpr="ParentDocumentAttributeId"
              autoExpandAll="true"
              [showRowLines]="true"
              [showBorders]="true"
              [columnAutoWidth]="true"
              (onSaving)="onAttributeSaving($event)">
  <dxo-editing [mode]="editingMode"
               [allowAdding]="false"
               [allowUpdating]="!isReadOnly"
               [allowDeleting]="false">
  </dxo-editing>
  <dxi-column dataField="DocumentAttributeName" [width]="200" [caption]="this.languageService.LNG('Label.Name')" [allowEditing]="false"></dxi-column>
  <dxi-column dataField="DocumentAttributeDescription" cellHintEnabled="true" [caption]="this.languageService.LNG('Label.Description')" [allowEditing]="false"></dxi-column>
  <dxi-column dataField="Value" [caption]="this.languageService.LNG('Label.Value')" [width]="100"></dxi-column>
</dx-tree-list>

